const styleSheet = () => ({
  container: {
    minHeight: '446px',
    width: '100%',
    maxWidth: '803px',
    '& #number-section': {
      marginBottom: 0,
    },
  },
  noRecordsContainer: {
    height: '163px', // Per invision
  },
  rightPaddedContainer: {
    width: '100%',
    minHeight: '312px',
    paddingRight: '32px',
  },
  row: {
    display: 'flex',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
  verticalAlign: {
    display: 'flex',
    justifcyContent: 'cetner',
  },
  large: {
    wordBreak: 'break-all',
    width: '50%',
  },
  small: {
    width: '30%',
    wordBreak: 'break-all',
  },
  smaller: {
    width: '20%',
    wordBreak: 'break-all',
  },
  columnHeader: {
    color: '#6373A4',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '11px',
    fontWeight: '500',
    lineHeight: '14px',
    marginBottom: '12.5px',
  },
  center: {
    textAlign: 'center',
  },
  right: {
    textAlign: 'right',
  },
  text: {
    color: '#051D39',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '14px',
    fontWeight: '500',
    marginBottom: '12.65px',
  },
  lowLineHeight: {
    lineHeight: '18px',
  },
  highLineHeight: {
    lineHeight: '22px',
  },
  lineBreak: {
    height: '1px',
    width: '755px',
    backgroundColor: '#D8DCE6',
    marginBottom: '27.3px',
    transform: 'translateX(-8px)',
  },
  pagingContainerNoMoreRecords: {
    transform: 'translateX(7px)',
  },
  pagingContainerRecordsRemaining: {
    transform: 'translateX(14px)',
  },
  noListsContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingTop: '35px',
  },
  noListsText: {
    color: '#6373A4',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '18px',
    paddingBottom: '27px',
  },
});

export default styleSheet;
